import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Download.css";
import appleImage from "../../assets/Apple.png";
import playStoreImage from "../../assets/PlayStore.png";
import DownloadImage from "../../assets/download.png";
import footerImage from "../../assets/FooterCar.png";

gsap.registerPlugin(ScrollTrigger);

export const Download = () => {
  useEffect(() => {
    const carImage = document.querySelector(".right-img img");

    gsap.fromTo(
      carImage,
      { x: "90%" },
      {
        x: "0%",
        scrollTrigger: {
          trigger: carImage,
          start: "bottom bottom",
          end: "top top",
          scrub: true,
        },
      }
    );
  }, []);

  return React.createElement(
    "section",
    { className: "download", id: "contact" },
    React.createElement(
      "div",
      { className: "left-text" },
      React.createElement(
        "div",
        { className: "only-text" },
        React.createElement("h2", null, "Experience Hassle-Free Auto Parts Sourcing"),
        React.createElement(
          "p",
          null,
          "Discover premium automotive components with fast delivery, trusted quality, and expert support—only at Motatec Asia."
        )
      ),
      React.createElement(
        "div",
        { className: "app-links" },
        React.createElement(
          "a",
          { href: "catalog.pdf", download: true },
          React.createElement(
            "button",
            { className: "app-btn" },
            React.createElement(
              "div",
              { className: "app-logo" },
              React.createElement("img", { src: DownloadImage, alt: "download" })
            ),
            React.createElement(
              "div",
              { className: "app-text" },
              React.createElement("p", null, "Download Product Catalog")
            )
          )
        )
      )
    ),
    React.createElement(
      "div",
      { className: "right-img" },
      React.createElement("img", { src: footerImage, alt: "car" })
    )
  );
};
